import React from 'react';
import Script from 'next/script';
import { generateGoogleBreadcrumbScript } from '../../helpers/google-breadcrumbs';
import { type BreadcrumbItem } from '../Breadcrumbs/BreadcrumbContainer';

const GoogleBreadcrumbScript = ({
  breadcrumbs,
  origin = 'http://localhost:4070',
}: {
  breadcrumbs: Array<BreadcrumbItem>;
  origin?: string;
}) => {
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }
  const generated = generateGoogleBreadcrumbScript(breadcrumbs, origin);
  if (!generated) {
    return null;
  }
  return (
    <Script type="application/ld+json" key="google-breadcrumb">
      {JSON.stringify(generated).replace(/(&quot;)/g, '"')}
    </Script>
  );
};

export default GoogleBreadcrumbScript;
